const NAMESPACE = 'app'

export default {
  LOGIN: `${NAMESPACE}_login`,
  LOGOUT: `${NAMESPACE}_logout`,
  GET_USER: `${NAMESPACE}_get_user`,
  SET_USER: `${NAMESPACE}_set_user`,
  AUTH_URL: `${NAMESPACE}_auth_url`
}



// WEBPACK FOOTER //
// ./src/store/modules/app/types.js